import React, { useEffect } from 'react';
import '../css/remixicon/remixicon.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import symbolDark from '../img/symbol_dark.png';
import * as ChannelService from '@channel.io/channel-web-sdk-loader';
import {  useNavigate,  useLocation  } from "react-router-dom";

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const Footer = () => {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 채널톡 초기화
    ChannelService.loadScript();
    ChannelService.boot({
        "pluginKey": `${process.env.REACT_APP_CHANNEL_SERVICE_KEY}`, // 환경변수 이름 수정
        "hideChannelButtonOnBoot": false, 
        "mobileParams": {
            "position": "right", 
            "bottom": "60px" 
        }
    });

    // GSAP 설정
    gsap.set(".page_title_bg", {
        height: window.innerHeight
    });
    gsap.to(".page_title_bg", {
        scale: 1,
        yPercent: 75,
        ease: "none",
        scrollTrigger: {
            trigger: ".page_title_bg",
            start: "top top",
            end: "bottom top",
            scrub: true
        }
    });

    AOS.init();
    
    let previousScroll;
    let windowScroll = window.pageYOffset || document.documentElement.scrollTop;
      const handleScroll = () => {
        const currentScroll = window.scrollY;
    
        if (currentScroll > previousScroll) {
          document.querySelector(".header").classList.add("down");
        } else {
          document.querySelector(".header").classList.remove("down");
        }

        if (currentScroll >= 50) {
          document.querySelector(".header").classList.add("bg");
        } else {
          document.querySelector(".header").classList.remove("bg");
        }
      
        if (currentScroll <= 50) {
          document.querySelector(".header").classList.remove("down");
        }
      
        previousScroll = currentScroll;
      };
    
      window.addEventListener("scroll", handleScroll);
    
       
      return () => {
        ChannelService.shutdown();
        window.removeEventListener("scroll", handleScroll);
    };
      }, []);

      //로그인 페이지로
      const handleLogin = () => {
        navigate(`/login` , { state: { from: location.pathname }} );
      };

  return (
    <footer className="footer">
      <div className="inner">
        <div className="footer_top">
          <a href="/privacy">개인정보취급방침</a>
        </div>
        <div className="footer_middle">
          <div className="footer_info">
            <div className="footer_logo">
              <img src={symbolDark} alt="Logo" />
            </div>
            <div className="footer_desc">
              <h4>(주)위즈팩토리</h4>
              <ul>
                <li className="address">
                  경상남도 창원시 창원대로 18번길 46 경남창원과학기술진흥원 1114호
                </li>
                <li><strong>TEL.</strong> 055-715-7737</li>
                <li><strong>FAX.</strong> 055-715-7738</li>
                <li><strong>E-mail</strong> wiz_biz@wiz-factory.com</li>
                <li><strong>대표</strong> 배흥열</li>
                <li><strong>사업자등록번호</strong> 165-81-02643</li>
                <li className="copyright">ⓒ <span className="strong">WIZ-FACTORY.</span> All Rights Reserved.</li>
              </ul>
            </div>
            <span></span>
          </div>
          <div className='footer_login'><a onClick={handleLogin}><i className="ri-settings-4-line"></i></a></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
